import React, { FC } from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface SiteIncidentHeaderProps {
    siteName: string;
    onReportIncident?: () => void;
}

const SiteIncidentHeader: FC<SiteIncidentHeaderProps> = ({ siteName, onReportIncident }) => {
    const navigate = useNavigate();

    return (
        <div className="incidents-site-header">
            <div className="header-left">
                <button
                    type="button"
                    className="back-arrow"
                    onClick={() => navigate(-1)}
                    aria-label="Go back">
                    <LeftOutlined />
                </button>
            </div>
            <div className="site-title-section">
                <h1 className="page-title">View Incidents</h1>
                <p className="page-subtitle">{siteName}</p>
            </div>
            <div className="header-actions">
                {onReportIncident && (
                    <Button type="primary" className="report-button" onClick={onReportIncident}>Report New Incident</Button>
                )}
            </div>
        </div>
    );
};

export default SiteIncidentHeader;
